import { SkeletonPage } from '@shopify/polaris'

export function Welcome() {
  return <></>
}

export function InitWelcome() {
  return <SkeletonPage primaryAction={true} />
}
